import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Collection from './collection';
import CollectionStore from '../../store/collection';
import Favorite from './favorite';
import { trackTime } from '../../utils/tracking.js';
import { withGigCardContext } from '../gig_card_context';
import { isEmpty } from 'lodash';
import './style.scss';

// constants
const gigsIloveKey = 'Gigs I Love',
    collectionDefault = { gigs: [], active: true },
    collectionsListDefault = { [gigsIloveKey]: collectionDefault };

class CollectGig extends Component {
    constructor(props) {
        super(props);

        this.saveCollection = this.saveCollection.bind(this);
        this.toggleCollection = this.toggleCollection.bind(this);
        this.removeGigFromAllCollections = this.removeGigFromAllCollections.bind(this);
        this.startTime = Date.now();
    }

    componentDidMount() {
        trackTime('collect-gig-component-did-mount', this.startTime, this.props.cardType);
    }

    componentWillUnmount() {
        trackTime('collect-gig-component-will-unmount', this.startTime, this.props.cardType);
    }

    toggleCollection(e, coll, isCollected, callback) {
        e.preventDefault();

        const newValue = !isCollected,
            ajaxType = newValue ? 'POST' : 'DELETE',
            {collections, gigId} = this.props,
            collectionsList = collections ? collections.collections : collectionsListDefault;

        return CollectionStore.toggleFavorite(ajaxType, gigId, coll).then((resp) => {
            if (resp === 'success') {
                const collection = collectionsList[coll] || collectionDefault;

                if (newValue) {
                    collection.gigs.push(gigId);
                } else {
                    collection.gigs = collection.gigs.filter((id) => id !== gigId);
                }

                const nextCollections = Object.assign({}, collectionsList, { [coll]: collection });

                this.props.updateCollections({ collections: nextCollections }, callback);
            }
        });
    }

    removeGigFromAllCollections(e, callback) {
        e.preventDefault();

        const {collections, gigId} = this.props,
            collectionsList = collections.collections;

        return Object.keys(collectionsList).forEach((keyName) => {
            if (collectionsList[keyName].gigs.includes(gigId)) {
                CollectionStore.toggleFavorite('DELETE', gigId, keyName).then((resp) => {
                    if (resp === 'success') {
                        const collection = collectionsList[keyName] || collectionDefault;
                        collection.gigs = collection.gigs.filter((id) => id !== gigId);

                        const nextCollections = Object.assign({}, collectionsList, { [keyName]: collection });

                        this.props.updateCollections({ collections: nextCollections }, callback);
                    }
                });
            }
        });
    }

    saveCollection(gigId, collectionKey) {

        return CollectionStore.newCollection(gigId, collectionKey).then((ajaxResp) => {
            if (ajaxResp === 'success') {
                const newCollection = {
                        [collectionKey]: {
                            gigs: [gigId],
                            active: true
                        }
                    },
                    collections = this.props.collections.collections;

                this.props.updateCollections({ collections: Object.assign({}, collections, newCollection) });
            }
        });
    }

    checkIsFavorited(gigId, collectionsList) {
        if (!this.props.user || !collectionsList) {
            return false;
        }

        const collections = collectionsList.collections;

        return Object.keys(collections).length ? this.collectionsContainGig(collections, gigId) : false;
    }

    collectionsContainGig(collections, gigId) {
        let inCollection = false;
        Object.keys(collections).forEach((keyName) => {
            if (!inCollection && collections[keyName].gigs.includes(gigId)) {
                inCollection = true;
            }
        });
        return inCollection;
    }

    render() {
        const { gigId, user, showCollMenu, cardType, cardSize, icon, collections, sellerId } = this.props,
            isFavorited = this.checkIsFavorited(gigId, collections),
            shouldShowCollMenu = !isEmpty(user) && showCollMenu;

        return (
            <div className="gig-fav">
                {shouldShowCollMenu && <Collection gigId={gigId} sellerId={sellerId} collections={collections} saveCollection={this.saveCollection} toggleCollection={this.toggleCollection} icon={icon} cardType={cardType} cardSize={cardSize}/>}
                <Favorite isFavorited={isFavorited} gigId={gigId} sellerId={sellerId} collections={collections} user={user} removeGigFromAllCollections={this.removeGigFromAllCollections} toggleCollection={this.toggleCollection} cardType={cardType} cardSize={cardSize}/>
            </div>
        );
    }
}

CollectGig.propTypes = {
    collections: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    gigId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    user: PropTypes.object,
    showCollMenu: PropTypes.bool,
    cardType: PropTypes.string,
    icon: PropTypes.string,
    updateCollections: PropTypes.func
};

const contextSelector = ({ cardType, cardSize, collections }) => ({ cardType, cardSize, collections });

export default withGigCardContext(contextSelector)(CollectGig);



// WEBPACK FOOTER //
// ./src/shared/collect_gig/index.js